import ApolloClient from 'apollo-boost';
import React, { Suspense } from 'react';
import { ApolloProvider } from 'react-apollo';
import ReactDOM from 'react-dom';
import Plugin from './containers/plugin';
// Import common styles
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/index.scss';

// The editor view is not required in plugin mode, keep it lazy-loaded
const App = React.lazy(() => import('./containers/app'));
// Target container for the telbee app
const CONTAINER_ID = 'telbee-plugin-container';

function render() {
    if (process.env.REACT_APP_BUILD_MODE !== 'editor') {
        // Setup the Apollo client before page load
        const client = new ApolloClient({
            uri: `${process.env.REACT_APP_API_URL}/graphql`
        });

        window.onload = () => {
            const existingContainer = document.querySelector(`#${CONTAINER_ID}`);
            if (!existingContainer) {
                // Create the plugin container
                const pluginContainer = document.createElement('div');
                // Set the ID to the expected value
                pluginContainer.setAttribute('id', CONTAINER_ID)
                // Finally, append it to the body when read
                document.body.appendChild(pluginContainer);
            }

            // Render the plugin into the container
            ReactDOM.render(
                // Set the graphql context for the plugin
                <ApolloProvider client={client}>
                    <Plugin demo={process.env.REACT_APP_BUILD_MODE === 'demo'} />
                </ApolloProvider>,
                document.getElementById(CONTAINER_ID)
            );
        }
    } else {
        // Render the app into the container
        ReactDOM.render(
            <Suspense fallback={<div>Loading...</div>}>
                <App />
            </Suspense>,
            document.getElementById(CONTAINER_ID));
    }
}

// Load the main CSS corresponding to the build environemnt
import(`./styles/index-${process.env.REACT_APP_BUILD_MODE}.scss`).then(render);